<template>
  <div id="clients-modal-parent">
    <Page title="クライアント管理">
      <template v-slot:content>
        <div class="table-action">
          <div>
            <div class="search-field">
              <SearchField
                @search="onSearch"
                :count="clients && clients.length"
                :tableData="clients"
                :filterColumns="filterColumns"
                :key="renewKey"
              />
            </div>
            <ActionButton title="新規追加" color="default" icon="plus" @click="onAddButtonClick" />
            <div class="create-trial-button">
              <ActionButton title="トライアル発行" color="default" icon="plus" @click="onCreateTrialButtonClick" />
            </div>
          </div>
        </div>
        <div class="uk-card uk-card-default uk-card-body">
          <Table :header="header" :tableData="clients" @column-click="onColumnClick" />
        </div>
      </template>
    </Page>
    <div class="uk-flex-top client-form-modal" uk-modal ref="modal" container="#clients-modal-parent" :bg-close="false">
      <ClientForm :key="formKey" :client="client" @submitted="onSubmitted" />
    </div>
    <div class="uk-flex-top trial-form-modal" uk-modal ref="trial-modal" :bg-close="false">
      <TrialAccountForm :key="formKey" @submitted="onTrialSubmitted" />
    </div>
  </div>
</template>
<style lang="scss" scoped>
@include table-action;
.search-field {
  margin-right: $spacing-medium;
}
.create-trial-button {
  margin-left: $spacing-small;
}
</style>
<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { Ref } from "vue-property-decorator";
import { ClientApi, Client, AuthApi } from "../../autogen";
import SearchField from "../atoms/SearchField.vue";
import Page from "../molecules/Page.vue";
import ActionButton from "../atoms/ActionButton.vue";
import Table from "../molecules/Table.vue";
import Moment from "moment-timezone";
import UIkit from "uikit";
import Router from "../../router";
import ClientForm from "../organisms/ClientForm.vue";
import TrialAccountForm from "../organisms/TrialAccountForm.vue";
import Store from "../../store";

@Options({
  components: {
    Page,
    ActionButton,
    Table,
    SearchField,
    ClientForm,
    TrialAccountForm
  }
})
export default class Clients extends Vue {
  clients: Client[] = [];
  client: Partial<Client> | null = null;
  query = "";
  header = [
    { title: "クライアント名", sortable: true, key: "name", width: "expand" },
    { title: "登録日時", sortable: true, key: "createdAt", width: 160 },
    { title: "ユーザー管理", type: "button", key: "users", width: 150 },
    { title: "編集", type: "button", key: "edit", width: 150 }
  ];
  filterColumns = ["name", "createdAt"];
  @Ref("modal") modal!: HTMLElement;
  @Ref("trial-modal") trialModal!: HTMLElement;
  @Ref("form") form!: HTMLElement;
  formKey = 0;
  renewKey = 0;

  private async loadData() {
    const response = await new ClientApi().getClients({ q: this.query });
    this.clients = response.data.map(datum =>
      Object.assign({}, datum, {
        createdAt: Moment(datum.createdAt)
          .tz(Moment.tz.guess())
          .format("YYYY/MM/DD HH:mm:ss")
      })
    );
    this.renewKey = Date.now();
  }
  async beforeMount() {
    await this.loadData();
  }
  onAddButtonClick() {
    this.client = null;
    this.prepareForm();
  }
  onCreateTrialButtonClick() {
    this.prepareTrialForm();
  }
  private closeForm() {
    UIkit.modal(this.modal).hide();
  }
  private closeTrialForm() {
    UIkit.modal(this.trialModal).hide();
  }
  private prepareForm() {
    this.formKey = Date.now();
    UIkit.modal(this.modal).show();
  }
  private prepareTrialForm() {
    this.formKey = Date.now();
    UIkit.modal(this.trialModal).show();
  }
  async onSubmitted() {
    this.closeForm();
    await new AuthApi().authenticate({}).then(resp => {
      if (resp.status === 200) {
        Store.getInstance().setAuth(resp.data);
      }
    });
    await this.loadData();
  }
  async onTrialSubmitted() {
    this.closeTrialForm();
    await new AuthApi().authenticate({}).then(resp => {
      if (resp.status === 200) {
        Store.getInstance().setAuth(resp.data);
      }
    });
    await this.loadData();
  }
  onColumnClick(location: { row: number; col: string }) {
    if (location.col === "edit") {
      this.client = this.clients[location.row];
      this.prepareForm();
    } else if (location.col === "users") {
      const client = this.clients[location.row];
      Router.push({ path: `/clients/${client.id}/users` });
    }
  }
  async onSearch(searchResult: [] | null) {
    if (searchResult) {
      this.clients = searchResult;
    } else {
      await this.loadData();
    }
  }
}
</script>
